import React from "react";
import styled from "styled-components";
import { AudioSrcDictType, ColumnType } from "./Type";

type TableProps = {
    columns_name_list: Array<ColumnType>;
    audio_src_list: Array<AudioSrcDictType>;
  };

function Table({ columns_name_list, audio_src_list }:TableProps){
  return (
    <StyledTable>
      <thead>
        <tr>
          {columns_name_list.map((column) => {
            const text_color = (
              column.column_name=="Song Name" || 
              column.column_name=="Music (Input)" ||
              column.column_name=="Wet vocal" ||
              column.column_name=="Dry vocal (GT)"
            )? "#778041" : "#AD653C"
            return (
            <th>
              <TableText font_size="15px" color={text_color}>
              {column.column_name}
              </TableText>
              <TableText font_size="12px" color={text_color}>
              {column.description}
              </TableText>
            </th>
          )})}
        </tr>
      </thead>
      <tbody>
        {audio_src_list.map(({song_name,input, wet_vocal, dry_vocal, sssynth, res_unet_decouple,proposed1,proposed2}) => (
          <tr>
            <td><TableText font_size="12px" color="">
                {song_name}
              </TableText></td>
            <td><TableAudio src={input} controls /></td>
            <td><TableAudio src={wet_vocal} controls /></td>
            <td><TableAudio src={dry_vocal} controls /></td>
            <td><TableAudio src={sssynth} controls /></td>
            <td><TableAudio src={res_unet_decouple} controls /></td>
            <td><TableAudio src={proposed1} controls /></td>
            <td><TableAudio src={proposed2} controls /></td>
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
}

const StyledTable = styled.table`
  margin-left: auto;
  margin-right: auto;
  table-layout: fixed; 
  width: 95%;
`

const TableAudio = styled.audio`
  width: 170px;
`
interface TableText {
  font_size: string;
  color: string;
}

const TableText = styled("body")<TableText>`
font-family: 'Inter';
font-style: normal;
font-weight: 900;
font-size: ${(props) => props.font_size};
margin: 5px;

color: ${(props) => props.color};
`

export default Table;